import Legend from './Legend';

export * from './Legend';
export default Legend;
